import { render, staticRenderFns } from "./EmailCollector.vue?vue&type=template&id=55dd6444&scoped=true&"
import script from "./EmailCollector.vue?vue&type=script&lang=js&"
export * from "./EmailCollector.vue?vue&type=script&lang=js&"
import style0 from "./EmailCollector.vue?vue&type=style&index=0&id=55dd6444&prod&lang=css&"
import style1 from "./EmailCollector.vue?vue&type=style&index=1&id=55dd6444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd6444",
  null
  
)

export default component.exports